import { HttpError } from '@wix/http-client';
import { GrpcStatusError } from '@wix/serverless-api';

export type TErrors =
  | 'NO_NETWORK_CONNECTION'
  | 'CAPTCHA_ACTION_INVALID'
  | 'CAPTCHA_REQUEST_INVALID'
  | 'RESOURCE_EXHAUSTED'
  | 'CAPTCHA_REQUIRED'
  | 'CAPTCHA_UNAVAILABLE'
  | 'CAPTCHA_SCORE_INVALID'
  | 'UNAVAILABLE'
  | 'UNKNOWN';

const errorMessages: Record<Partial<TErrors>, string> = {
  NO_NETWORK_CONNECTION:
    'charge-locator.results_page.toast.network_error.unable_to_search_charge',
  CAPTCHA_ACTION_INVALID:
    'charge-locator.results_page.toast.techincal_error.unable_to_search_charge',
  CAPTCHA_REQUEST_INVALID:
    'charge-locator.results_page.toast.techincal_error.unable_to_search_charge',
  UNKNOWN:
    'charge-locator.results_page.toast.techincal_error.unable_to_search_charge',
  CAPTCHA_REQUIRED:
    'charge-locator.charge_locator_form.toast.server_error.major_server_error_invalid_arguement',
  CAPTCHA_SCORE_INVALID:
    'charge-locator.charge_locator_form.toast.server_error.major_server_error_invalid_arguement',
  CAPTCHA_UNAVAILABLE:
    'charge-locator.charge_locator_form.toast.server_errror.server_not_delivering_all_info',
  RESOURCE_EXHAUSTED:
    'charge-locator.charge_locator_form.toast.server_error.major_server_error_invalid_arguement',
  UNAVAILABLE:
    'charge-locator.charge_locator_form.toast.server_errror.server_not_delivering_all_info',
};

export const getGrpsApplicationErrorCode = (
  e: unknown,
): TErrors | undefined => {
  let error: GrpcStatusError | undefined;

  if (typeof e === 'object') {
    error = (e as HttpError<GrpcStatusError>)?.response?.data;
  }
  return (error?.details?.applicationError?.code as TErrors) || undefined;
};

export const getErrorMessage = (errorCode: TErrors | undefined): string => {
  return errorMessages[errorCode || 'UNKNOWN'];
};

export const getNoNetworkError = (e: unknown): TErrors | undefined => {
  return typeof e === 'object' &&
    !(e as HttpError).response &&
    (!window.navigator.onLine ||
      (e as HttpError).message.toLowerCase().includes('network error'))
    ? 'NO_NETWORK_CONNECTION'
    : undefined;
};
